import { ArchiveFilter } from '../constants/archive-filter.enum';
import { ProductTab } from '../constants/product-tab.enum';

export const isArchiveFilter = (value: string | null): value is ArchiveFilter => Object.values<string | null>(ArchiveFilter).includes(value);

export const isProductTab = (value: string | null): value is ProductTab => Object.values<string | null>(ProductTab).includes(value);
